// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"7b6f79ae","223":"cc42559e","352":"802242fc","720":"3df5bb95","811":"57efb6ae"}[chunkId] + ".chunk.js";
};